import request from '@/utils/request'

const prefix = '/django_rest/company/job-posting-channel/account'

export default {
  getJobPostingChannelAccountList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getJobPostingChannelAccount (id) {
    return request.get(`${prefix}/${id}/`)
  },
  createJobPostingChannelAccount (data) {
    return request.post(`${prefix}/`, data)
  },
  updateJobPostingChannelAccount (id, data) {
    return request.put(`${prefix}/${id}/`, data)
  },
  deleteJobPostingChannelAccount (id) {
    return request.delete(`${prefix}/${id}/`)
  }
}
